import React from "react";
import { observer } from "mobx-react-lite";
import {
	BettingData,
	IPlayerStatistics,
} from "@data-types/sport-stats/SportStatsTypes";
import ErrorWrapper from "../ErrorWrapper";
import { PlayerStatisticsTemplate } from "@features/offer/shared/statistics/components/player-betting-types";

export default observer(function PlayerStatistics(props: {
	bettingTypeStats: BettingData | null;
	bettingTypeAbrv?: string;
}) {
	if (!props.bettingTypeAbrv || !props.bettingTypeStats) {
		return null;
	}

	return (
		<ErrorWrapper>
			<PlayerStatisticsTemplate
				data={props.bettingTypeStats as IPlayerStatistics["data"]}
			/>
		</ErrorWrapper>
	);
});
